import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../../containers/common/Loader'

import * as authSelectors from '../../../selectors/auth'
import * as stopCallSelectors from '../../../selectors/job/stopCall'
import { actions as jobStopCallActions } from '../../../redux/modules/jobFunctions/jobStopCallActions'

import Notes from '../../notes/Notes'

const propTypes = {
  stopCallId: PropTypes.number.isRequired,
  notes: PropTypes.array,
  userId: PropTypes.number.isRequired,

  // actions
  stopCallNotesRefresh: PropTypes.func.isRequired,
  createNote: PropTypes.func.isRequired,
  updateNote: PropTypes.func.isRequired,
  deleteNote: PropTypes.func.isRequired
}

class StopCallNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null
    }
  }

  componentWillMount() {
    const { stopCallId, stopCallNotesRefresh } = this.props
    stopCallNotesRefresh(stopCallId)
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    const { userId, stopCallId, createNote } = this.props
    createNote({
      content: params,
      userId: userId,
      stopCallId: stopCallId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    const { updateNote, stopCallId } = this.props
    const { currentNoteId } = this.state
    updateNote({
      stopCallId: stopCallId,
      noteId: currentNoteId,
      content: params
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    const { deleteNote, stopCallId } = this.props
    const { currentNoteId } = this.state
    deleteNote({
      noteId: currentNoteId,
      stopCallId: stopCallId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  render() {
    const { notes, userId, stopCallId } = this.props
    if (!notes) {
      return <Loader />
    }
    return (
      <div>
        {stopCallId && (
          <Notes
            // notes props
            currentNote={this.state.currentNote}
            currentNoteId={this.state.currentNoteId}
            notes={notes}
            handleToggleNoteEditArea={this.handleToggleNoteEditArea}
            noteAddEditContainer={this.state.noteAddEditContainer}
            createNote={this.createNote}
            handleRowNoteClick={this.handleRowNoteClick}
            updateNote={this.updateNote}
            userId={userId}
            deleteNote={this.deleteNote}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  notes: stopCallSelectors.getStopCallNotes(state, props),
  userId: authSelectors.getUserId(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  stopCallNotesRefresh: stopCallId => dispatch(jobStopCallActions.stopCallNotesRefresh(stopCallId)),
  createNote: ({ stopCallId, content, userId }) =>
    dispatch(jobStopCallActions.createNote({ stopCallId, content, userId })),
  updateNote: ({ stopCallId, noteId, content }) =>
    dispatch(jobStopCallActions.updateNote({ stopCallId, noteId, content })),
  deleteNote: ({ noteId, stopCallId }) =>
    dispatch(jobStopCallActions.deleteNote({ noteId, stopCallId }))
})

StopCallNotes.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StopCallNotes))



// WEBPACK FOOTER //
// ./src/components/jobs/stop_call/StopCallsNotes.js